import React from 'react';

import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <path d="M20 15C21.66 15 22.99 13.66 22.99 12C22.99 10.34 21.66 9 20 9C18.34 9 17 10.34 17 12C17 13.66 18.34 15 20 15ZM12 15C13.66 15 14.99 13.66 14.99 12C14.99 10.34 13.66 9 12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15ZM12 17C9.67 17 5 18.17 5 20.5V23H19V20.5C19 18.17 14.33 17 12 17ZM20 17C19.71 17 19.38 17.02 19.03 17.05C20.19 17.89 21 19.02 21 20.5V23H27V20.5C27 18.17 22.33 17 20 17Z" />,
  'People',
  { viewBox: '0 0 32 32' },
);
